
import { types } from 'mobx-state-tree';

const DashBoardSetData = types
        .model('DashBoardSet',{
              dashBoardSet:types.maybe(types.string),
        })
        .views((self) => ({
            get me() {
                return { ...self };
            },
        }))
        .actions((self) => ({
            async getStoreData() {
                const response = await UtilService.dashboardDataGet();
                if (response.data) {
                    //console.log('res ======================== ', response.data);
                    self.setData(response.data);
                }
            },
            async setStoreData(setData){
                const response = await UtilService.dashboardDataSet(setData);
                if (response.data) {
                    //console.log('res ======================== ', response.data);
                    self.setData(response.data);
                }
                self.dashBoardSet = String(setData);
            },
            async setData(setData){
                self.dashBoardSet = String(setData);
            },
            async getData(setData){
                return self.dashBoardSet;
            },
        }));

export default DashBoardSetData;